import { formatText } from '@arnold/common';

const FormatQuestion = ({ text }: { text: string }) => {
  return <span className={'font-weight-bold'}>{formatText(text)}</span>;
};

export default FormatQuestion;
